var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox-group',{staticClass:"appup-checkbox",attrs:{"id":_vm.id,"options":_vm.checkboxGroupOptions,"state":_vm.state},on:{"change":_vm.onSelect},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/inputs/checkbox/checkbox.vue